module.exports = __webpack_public_path__ + "assets/img/gift-2-d-9b826bba.png";